import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// The stylesheet is preloaded in the document, then applied after the initial
// document has been parsed so it never blocks first paint.
const fontStylesheet = document.getElementById("fcmre-font-stylesheet") as HTMLLinkElement | null;
if (fontStylesheet) fontStylesheet.rel = "stylesheet";

createRoot(document.getElementById("root")!).render(<App />);
